var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("form", { attrs: { "data-vv-scope": "entity-docdigital" } }, [
    _c("div", { staticClass: "row mb-5" }, [
      _c(
        "div",
        { staticClass: "col-12 mt-3" },
        [
          _c("list-subject-types", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required",
                expression: "'required'"
              }
            ],
            ref: "subjectEntity",
            staticClass: "w-100",
            attrs: {
              autocomplete: "",
              clearable: false,
              danger: _vm.errors.has("entity-docdigital.entity"),
              "danger-text": _vm.errors.first("entity-docdigital.entity"),
              "data-vv-as": "entidad",
              label: "Entidad",
              name: "entity",
              "data-cy": "entity"
            },
            model: {
              value: _vm.editGroup.entidadDocDigital,
              callback: function($$v) {
                _vm.$set(_vm.editGroup, "entidadDocDigital", $$v)
              },
              expression: "editGroup.entidadDocDigital"
            }
          })
        ],
        1
      ),
      _c("div", { staticClass: "col-md-12 mt-3" }, [
        _c(
          "div",
          { staticStyle: { float: "right" } },
          [
            _c(
              "vs-button",
              {
                staticClass: "action",
                attrs: {
                  color: "primary",
                  type: "border",
                  icon: "save",
                  "data-cy": "save"
                },
                on: {
                  click: function($event) {
                    return _vm.saveChanges()
                  }
                }
              },
              [_vm._v(" Guardar ")]
            )
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }